import React, { useEffect, useState } from "react";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import {
  Card,
  Col,
  ConfigProvider,
  Modal,
  Progress,
  Row,
  Table,
  Tabs,
  Tag,
  Typography,
  Form,
  Upload,
  Image,
} from "antd";
import { color, icon } from "../../../resource";
import Permission from "../../../components/Permission/Permission";
import {
  DeleteFilled,
  EditOutlined,
  LinkOutlined,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { CardContainer } from "../../../components/Card/CardContainer";
import Button from "../../../components/Button/Button";
import Text from "../../../components/Text/Text";
import { numberFormatter } from "../../../utility/Formatter";
import Select from "../../../components/Select/Select";
import Input from "../../../components/Input/Input";
import { FlexCol } from "../../../components/Container/Container";
import { ActionBtn } from "../../../components/Button/TableActionButton";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  createAdjustCoShop,
  getCoDiscoutType,
  getDetailShopAdjustmentList,
  getDetailShopCoByCusComId,
  getDetailShopCoList,
  getDetailShopHistoryList,
  getShopCoListByShopId,
} from "../../../datasource/CODiscountDatasource";
import { onInputNumberKeyPress } from "../../../utility/validator";
import { useEffectOnce } from "react-use";
import { mapStatus } from "../CODiscountList/IndexCODiscountList";
import { useMessageContext } from "../../../context/MessageProvider";
import { FixedType } from "rc-table/lib/interface";
import { useInvoiceExpandable } from "../CODiscountComponent";

export const DetailCoDiscountEachShop: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[pathSplit.length - 2];
  const navigateType = pathSplit[pathSplit.length - 1];
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [adjustTypeModal, setAdjustTypeModal] = useState(false);
  const [adjustFormModal, setAdjustFormModal] = useState<any>({ type: 0, open: false });
  const [coType, setCoType] = useState<any>([]);
  const [page, setPage] = useState("1");
  const historyExpandable = useInvoiceExpandable(profile.company);

  const [tab, setTab] = useState("coList");
  const [detail, setDetail] = useState<any>({});
  const [coList, setCoList] = useState<any>([]);
  const [historyList, setHistoryList] = useState<any>([]);
  const [adjustmentList, setAdjustmentList] = useState<any>([]);

  const [searchTypeId, setSearchTypeId] = useState<string | undefined>(undefined);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [searchTypeAdjustment, setSearchTypeAdjustment] = useState<string | undefined>(undefined);

  const [loading, setLoading] = useState(false);

  const fetchDetail = async () => {
    await getDetailShopCoByCusComId({ customerCompanyId: id }).then((res) => {
      setDetail(res);
    });
  };

  const fetchDataType = async () => {
    await getCoDiscoutType({
      company: profile?.company,
      page: 1,
      take: 999,
      status: true,
    }).then((res) => {
      setCoType(res.data);
    });
  };

  useEffectOnce(() => {
    fetchDataType();
  });

  const fetchAdjustmentList = async () => {
    getDetailShopAdjustmentList({
      customerCompanyId: id,
      page: Number(page),
      take: 10,
      type: searchTypeAdjustment,
      search: searchText,
    }).then((res) => {
      setAdjustmentList(res);
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchDetail();
    if (tab === "coList") {
      getDetailShopCoList({
        customerCompanyId: id,
        page: Number(page),
        take: 10,
        creditMemoTypeId: searchTypeId,
        search: searchText,
      }).then((res) => {
        setCoList(res);
      });
    } else if (tab === "historyList") {
      getDetailShopHistoryList({
        customerCompanyId: id,
        page: Number(page),
        take: 10,
        creditMemoTypeId: searchTypeId,
        search: searchText,
      }).then((res) => {
        const mapData = res.data.map((item: any) => ({
          ...item,
          rowKey: `${item.orderNo}-${item.coId}`,
        }));
        setHistoryList({ ...res, data: mapData });
      });
    } else if (tab === "adjustment") {
      fetchAdjustmentList();
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [tab, searchTypeId, searchText, page, searchTypeAdjustment]);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title='รายละเอียดร้านค้า'
        customBreadCrumb={
          <BreadCrumb
            data={[
              {
                text: navigateType === "coType" ? "ส่วนลดประเภท CO" : "รายละเอียดส่วนลด",
                path: -1,
              },
              {
                text: "รายละเอียดร้านค้า",
                path: window.location.pathname,
              },
            ]}
          />
        }
        extra={
          <Permission permission={["coDiscountEachShop", "edit"]}>
            <Col>
              <Button
                title='ปรับยอดส่วนลด'
                icon={<EditOutlined />}
                onClick={() => setAdjustTypeModal(true)}
              />
            </Col>
          </Permission>
        }
      />
    );
  };
  const ProgressCard = () => {
    return (
      <Card
        bodyStyle={{
          padding: "12px ",
          alignItems: "center",
          backgroundColor: "#FAFAFA",
        }}
      >
        <Row justify={"space-between"} gutter={8} align='middle'>
          <Col>
            <Row justify={"start"} gutter={8} align='middle'>
              <Col>
                <Tag
                  color='#0068F4'
                  style={{
                    backgroundColor: `#EEF6FE`,
                    borderRadius: "4px",
                  }}
                >
                  <Typography.Text
                    style={{
                      color: "#0068F4",
                      fontFamily: "IBM Plex Sans Thai",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    {detail?.coCount || 0} ส่วนลด
                  </Typography.Text>
                </Tag>
              </Col>
              <Col>
                <Tag
                  color='#0068F4'
                  style={{
                    backgroundColor: `#EEF6FE`,
                    borderRadius: "4px",
                  }}
                >
                  <Typography.Text
                    style={{
                      color: "#0068F4",
                      fontFamily: "IBM Plex Sans Thai",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    {detail?.orderCount || 0} ออเดอร์
                  </Typography.Text>
                </Tag>
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <div style={{ paddingBottom: "10px" }}>
          <span
            className='card-label font-weight-bolder text-dark'
            style={{ fontSize: 20, fontWeight: "bold" }}
          >
            {detail?.customerName}
          </span>
        </div>
        <Progress
          percent={
            detail?.used && detail?.totalDiscount ? (detail?.used / detail?.totalDiscount) * 100 : 0
          }
          style={{ width: "100%" }}
          percentPosition={{ align: "end", type: "inner" }}
          size={["default", 20]}
          strokeColor='#0068F4'
          format={(percent) => (
            <Text level={6} color='white' fontWeight={600}>
              {numberFormatter((detail?.used / detail?.totalDiscount) * 100, 2)}%
            </Text>
          )}
        />
        <Row justify={"space-between"} gutter={8} align='middle' style={{ paddingTop: "5px" }}>
          <Col>
            <Text>ใช้ไป {numberFormatter(detail?.used || 0)} ฿</Text>
          </Col>
          <Col>
            <Text>
              <b>คงเหลือ {numberFormatter(detail?.remaining || 0)} /</b>{" "}
              {numberFormatter(detail?.totalDiscount || 0)} ฿
            </Text>
          </Col>
        </Row>
      </Card>
    );
  };
  const ShopInfoCard = () => {
    return (
      <Card
        bodyStyle={{
          padding: "12px ",
          alignItems: "center",
          backgroundColor: "#FAFAFA",
        }}
      >
        <Row style={{ paddingBottom: "10px" }}>
          <Col span={12}>
            <Row justify={"start"}>
              <Col span={10}>
                <Text color='Text3'>ชื่อร้านค้า</Text>
              </Col>
              <Col span={14}>
                <Text>{detail?.customerName}</Text>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify={"space-between"}>
              <Col span={10}>
                <Text color='Text3'>จังหวัด</Text>
              </Col>
              <Col span={14}>
                <Text>{detail?.province || "-"}</Text>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row justify={"start"}>
              <Col span={10}>
                <Text color='Text3'>ชื่อเจ้าของร้าน</Text>
              </Col>
              <Col span={14}>
                <Text>{detail?.ownerName || "-"}</Text>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify={"space-between"}>
              <Col span={10}>
                <Text color='Text3'>เขต</Text>
              </Col>
              <Col span={14}>
                <Text>{detail?.zone || "-"}</Text>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    );
  };
  const TabCoList = () => {
    const columnCoList: any = [
      {
        title: "ชื่อรายการ",
        dataIndex: "name",
        key: "name",
        width: "25%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value}</Text>
                <Text color='Text3' level={6}>
                  {row.code} • {dayjs(row.startDate).format("DD/MM/YYYY")} -{" "}
                  {dayjs(row.endDate).format("DD/MM/YYYY")}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ประเภทส่วนลด",
        dataIndex: "creditMemoTypeName",
        key: "creditMemoTypeName",
        align: "center",
        width: "15%",
        render: (value: any, row: any, index: number) => {
          const typeName = coType.find(
            (type: any) => type.creditMemoTypeId === row.creditMemoTypeId,
          );

          return {
            children: (
              <FlexCol>
                <Tag style={{ backgroundColor: `${typeName?.color}20`, border: "none" }}>
                  <Typography.Text
                    style={{
                      color: typeName?.color,
                      fontFamily: "IBM Plex Sans Thai",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    {typeName?.code} • {typeName?.nameTh}
                  </Typography.Text>
                </Tag>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ส่วนลดรวม",
        dataIndex: "quotaAmount",
        key: "quotaAmount",
        width: "12%",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "flex-end" }}>
                <Text>{numberFormatter(value)} ฿</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ใช้ไป",
        dataIndex: "quotaUsed",
        key: "quotaUsed",
        align: "center",
        width: "12%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "flex-end" }}>
                <Text color={value > 0 ? "error" : "Text1"}>
                  {value > 0 ? `-${numberFormatter(value)}` : numberFormatter(value)} ฿
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "คงเหลือ",
        dataIndex: "remaining",
        key: "remaining",
        align: "center",
        width: "12%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "flex-end" }}>
                <Text color={value > 0 ? "EmeraldGreen" : "Text1"}>{numberFormatter(value)} ฿</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "วิธีคิดส่วนลด",
        dataIndex: "coType",
        key: "coType",
        width: "10%",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>{value === "SKU" ? "บาท (฿) / หน่วย" : "% ของยอดบิล"}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "สถานะของรายการ",
        dataIndex: "coStatus",
        key: "coStatus",
        width: "15%",
        align: "center",
        render: (value: any, row: any, index: number) => {
          const calDate = dayjs(row?.endDate).diff(dayjs(), "day");
          const calDateStart = dayjs(row?.startDate).diff(dayjs(), "day");
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Tag
                  style={{
                    backgroundColor: mapStatus(value)?.bgColor,
                    border: "none",
                  }}
                >
                  <Text style={{ color: mapStatus(value)?.textColor }} level={6} fontWeight={600}>
                    {mapStatus(value)?.text}{" "}
                    {calDate <= 7 && value.includes("NEAR") ? `(${calDate} วัน)` : ""}
                    {calDateStart > 0 && value === "ACTIVE" ? `(รอเริ่ม)` : ""}
                  </Text>
                </Tag>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "สถานะของร้าน",
        dataIndex: "status",
        key: "status",
        align: "center",
        width: "10%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Tag
                  style={{
                    backgroundColor: mapStatus(value)?.bgColor,
                    border: "none",
                  }}
                >
                  <Text style={{ color: mapStatus(value)?.textColor }} level={6} fontWeight={600}>
                    {mapStatus(value)?.text}{" "}
                  </Text>
                </Tag>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "หมายเหตุถึง Sale",
        dataIndex: "latestDealerRemarkText",
        key: "latestDealerRemarkText",
        width: "12%",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "หมายเหตุถึง Dealer",
        dataIndex: "latestSaleRemarkText",
        key: "latestSaleRemarkText",
        width: "12%",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "จัดการ",
        dataIndex: "action",
        key: "action",
        width: "6%",
        align: "center",
        fixed: "right" as FixedType | undefined,
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Permission permission={["coDiscountList", "view"]}>
                  <ActionBtn
                    onClick={() =>
                      navigate("/newDiscountCo/detailCODiscountList/" + row.coId + "/coEachShop")
                    }
                    icon={<UnorderedListOutlined />}
                  />
                </Permission>
              </FlexCol>
            ),
          };
        },
      },
    ];

    return (
      <>
        <Row justify={"start"} gutter={8}>
          <Col span={4}>
            <Select
              value={searchTypeId}
              onChange={(e) => {
                setPage("1");
                setSearchTypeId(e);
              }}
              data={
                coType?.map((type: any) => ({
                  label: type.nameTh,
                  value: type.creditMemoTypeId,
                  key: type.creditMemoTypeId,
                })) || []
              }
              placeholder='ประเภทส่วนลดทั้งหมด'
            />
          </Col>
          <Col span={8}>
            <Input
              defaultValue={searchText}
              allowClear
              placeholder='ค้นหาชื่อรายการ'
              suffix={<SearchOutlined />}
              onPressEnter={(e) => {
                setPage("1");
                setSearchText(e.currentTarget.value);
              }}
              onChange={(e) => {
                if (!e.target.value) {
                  setSearchText(undefined);
                }
              }}
            />
          </Col>
          <Col style={{ paddingTop: "6px" }}>
            <Text color='Text3'>ทั้งหมด {coList?.total} รายการ</Text>
          </Col>
        </Row>
        <br />
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerColor: "#FAFAFA",
                headerBg: "#1B4586",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
              },
            },
          }}
        >
          <Table
            loading={loading}
            columns={columnCoList}
            dataSource={coList?.data || []}
            tableLayout='fixed'
            scroll={{
              x: 2500,
            }}
            pagination={{
              pageSize: 10,
              current: Number(page),
              total: coList?.total || 0,
              showSizeChanger: false,
              position: ["bottomCenter"],
              onChange: (page) => {
                setPage(String(page));
              },
            }}
          />
        </ConfigProvider>
      </>
    );
  };
  const TabHistoryList = () => {
    const columnHistory: any = [
      {
        title: "วันที่",
        dataIndex: "date",
        key: "date",
        align: "center",

        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>{dayjs(value).format("DD/MM/YYYY")}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "Order NO.",
        dataIndex: "orderNo",
        key: "orderNo",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text
                  color='primary'
                  style={{ cursor: "pointer" }}
                  onClick={() => value && window.open(`/order/${row.orderId}`, "_blank")}
                >
                  {value ? <u>{value}</u> : "-"}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ประเภทส่วนลด",
        dataIndex: "creditMemoTypeName",
        key: "creditMemoTypeName",
        align: "center",
        width: "20%",
        render: (value: any, row: any, index: number) => {
          const typeName = coType.find((type: any) => type.nameTh === row.creditMemoTypeName);
          return {
            children: (
              <FlexCol>
                <Tag style={{ backgroundColor: `${typeName?.color}20`, border: "none" }}>
                  <Typography.Text
                    style={{
                      color: typeName?.color,
                      fontFamily: "IBM Plex Sans Thai",
                      fontSize: 15,
                      fontWeight: "bold",
                    }}
                  >
                    {typeName?.code} • {typeName?.nameTh}
                  </Typography.Text>
                </Tag>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ชื่อรายการ",
        dataIndex: "coName",
        key: "coName",
        width: "30%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value || "-"}</Text>
                <Text color='Text3' level={6}>
                  {row.coCode} • {dayjs(row.startDate).format("DD/MM/YYYY")} -{" "}
                  {dayjs(row.endDate).format("DD/MM/YYYY")}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "SO",
        dataIndex: "soNo",
        key: "soNo",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text
                  color={value ? "primary" : "Text1"}
                  style={{ cursor: "pointer" }}
                  onClick={() => value && window.open(`/order/${row.orderId}`, "_blank")}
                >
                  {value ? <u>{value}</u> : "-"}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "จำนวนสินค้ารวม",
        dataIndex: "deducted",
        key: "deducted",
        align: "center",
        hidden: historyList?.coProducts?.length > 0 ? false : true,
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>
                  {row.productQuantities.map((pq: any) => pq.quantity + " " + pq.unit).join(", ")}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ยอดที่หัก",
        dataIndex: "deducted",
        key: "deducted",
        align: "center",
        fixed: "right" as FixedType | undefined,
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "flex-end" }}>
                <Text color={row.entryType === "REFUND" ? "success" : "error"}>
                  {row.entryType === "REFUND"
                    ? `+${numberFormatter(value)}`
                    : `-${numberFormatter(value)}`}{" "}
                  ฿
                </Text>
              </FlexCol>
            ),
          };
        },
      },
    ];

    return (
      <>
        <Row justify={"start"} gutter={8}>
          <Col span={4}>
            <Select
              value={searchTypeId}
              onChange={(e) => {
                setPage("1");
                setSearchTypeId(e);
              }}
              data={
                coType?.map((type: any) => ({
                  label: type.nameTh,
                  value: type.creditMemoTypeId,
                  key: type.creditMemoTypeId,
                })) || []
              }
              placeholder='ประเภทส่วนลดทั้งหมด'
            />
          </Col>
          <Col span={8}>
            <Input
              defaultValue={searchText}
              allowClear
              placeholder='ค้นหาชื่อรายการส่วนลด,SO / Invoice หรือ Order No.'
              suffix={<SearchOutlined />}
              onPressEnter={(e) => {
                setPage("1");
                setSearchText(e.currentTarget.value);
              }}
              onChange={(e) => {
                if (!e.target.value) {
                  setSearchText(undefined);
                }
              }}
            />
          </Col>
          <Col style={{ paddingTop: "6px" }}>
            <Text color='Text3'>ทั้งหมด {historyList?.total} รายการ</Text>
          </Col>
        </Row>
        <br />
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerColor: "#FAFAFA",
                headerBg: "#1B4586",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
              },
            },
          }}
        >
          <Table
            loading={loading}
            rowKey='rowKey'
            columns={columnHistory}
            dataSource={historyList?.data || []}
            {...(historyList?.data?.some((item: any) => item.invoices?.length > 0) && {
              expandable: historyExpandable,
            })}
            tableLayout='fixed'
            scroll={{
              x: 1400,
            }}
            pagination={{
              pageSize: 10,
              current: Number(page),
              total: historyList?.total || 0,
              showSizeChanger: false,
              position: ["bottomCenter"],
              onChange: (page) => {
                setPage(String(page));
              },
            }}
          />
        </ConfigProvider>
      </>
    );
  };
  const TabAdjustment = () => {
    const [openImg, setOpenImg] = useState<any>({ open: false, value: undefined });

    const columnAdjustment: any = [
      {
        title: "วันที่",
        dataIndex: "createdAt",
        key: "createdAt",
        align: "center",
        width: "10%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>{dayjs(value).format("DD/MM/YYYY")}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ประเภท",
        dataIndex: "type",
        key: "type",
        align: "center",
        width: "8%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Tag
                  style={{
                    border: "none",
                    backgroundColor: value.includes("ADD") ? "#F0FDF4" : "#FEECEC",
                  }}
                >
                  <Text color={value.includes("ADD") ? "success" : "error"} fontWeight={600}>
                    {value.includes("ADD") ? "เพิ่มยอด" : "ลดยอด"}{" "}
                  </Text>
                </Tag>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ชื่อรายการ",
        dataIndex: "coName",
        key: "coName",
        align: "center",
        width: "25%",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value}</Text>
                <Text color='Text3' level={6}>
                  {row.coCode} • {dayjs(row.startDate).format("DD/MM/YYYY")} -{" "}
                  {dayjs(row.endDate).format("DD/MM/YYYY")}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "หมายเหตุในการปรับยอด",
        dataIndex: "reason",
        key: "reason",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ดูไฟล์แนบ",
        dataIndex: "attachmentUrl",
        key: "attachmentUrl",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <>
                <FlexCol style={{ alignItems: "center" }}>
                  {value ? (
                    <Text
                      color='primary'
                      onClick={() => setOpenImg({ open: true, value: value })}
                      style={{ cursor: "pointer" }}
                    >
                      <LinkOutlined />
                      &nbsp;ดูไฟล์แนบ
                    </Text>
                  ) : (
                    "-"
                  )}
                </FlexCol>
              </>
            ),
          };
        },
      },
      {
        title: "ดำเนินการโดย",
        dataIndex: "createdBy",
        key: "createdBy",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>{value}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "จำนวน",
        dataIndex: "signedAmount",
        key: "signedAmount",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "flex-end" }}>
                <Text color={value > 0 ? "success" : "error"}>
                  {value > 0 ? "+" : ""}
                  {numberFormatter(value)} ฿
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "จัดการ",
        dataIndex: "action",
        key: "action",
        width: "8%",
        align: "center",
        fixed: "right" as FixedType | undefined,
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Permission permission={["coDiscountList", "view"]}>
                  <ActionBtn
                    onClick={() =>
                      navigate("/newDiscountCo/detailCODiscountList/" + row.coId + "/coEachShop")
                    }
                    icon={<UnorderedListOutlined />}
                  />
                </Permission>
              </FlexCol>
            ),
          };
        },
      },
    ];

    return (
      <>
        <Row justify={"start"} gutter={8}>
          <Col span={4}>
            <Select
              data={[
                { label: "เพิ่มลด", value: "ADJUST_ADD", key: "ADJUST_ADD" },
                { label: "ลดยอด", value: "ADJUST_SUB", key: "ADJUST_SUB" },
              ]}
              placeholder='ประเภททั้งหมด'
              value={searchTypeAdjustment}
              onChange={(e) => {
                setPage("1");
                setSearchTypeAdjustment(e);
              }}
            />
          </Col>
          <Col span={8}>
            <Input
              defaultValue={searchText}
              allowClear
              placeholder='ค้นหาชื่อรายการ'
              suffix={<SearchOutlined />}
              onPressEnter={(e) => {
                setPage("1");
                setSearchText(e.currentTarget.value);
              }}
              onChange={(e) => {
                if (!e.target.value) {
                  setSearchText(undefined);
                }
              }}
            />
          </Col>
          <Col style={{ paddingTop: "6px" }}>
            <Text color='Text3'>ทั้งหมด {adjustmentList?.total} รายการ</Text>
          </Col>
        </Row>
        <br />
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerColor: "#FAFAFA",
                headerBg: "#1B4586",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
              },
            },
          }}
        >
          <Table
            loading={loading}
            columns={columnAdjustment}
            dataSource={adjustmentList?.data || []}
            scroll={{
              x: 1600,
            }}
            pagination={{
              pageSize: 10,
              current: Number(page),
              total: adjustmentList?.total || 0,
              showSizeChanger: false,
              position: ["bottomCenter"],
              onChange: (page) => {
                setPage(String(page));
              },
            }}
          />
        </ConfigProvider>
        {openImg.open && (
          <Image
            style={{ display: "none" }}
            src={openImg.value || undefined}
            preview={{
              visible: openImg.open,
              onVisibleChange: (visible) =>
                setOpenImg((prev) => ({
                  ...prev,
                  open: visible,
                })),
            }}
          />
        )}
      </>
    );
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <br />
        <ProgressCard />
        <br />
        <ShopInfoCard />
        <br />
        <Tabs
          activeKey={tab}
          onChange={(key) => {
            setTab(key);
            setPage("1");
            setSearchTypeId(undefined);
            setSearchText(undefined);
            setSearchTypeAdjustment(undefined);
          }}
          style={{ fontFamily: "IBM Plex Sans Thai" }}
          items={[
            {
              label: `CO ที่ร้านนี้ได้รับ`,
              key: "coList",
              children: <TabCoList />,
            },
            {
              label: `ประวัติการใช้`,
              key: "historyList",
              children: <TabHistoryList />,
            },
            {
              label: `ปรับยอด`,
              key: "adjustment",
              children: <TabAdjustment />,
            },
          ]}
        />
      </CardContainer>
      {adjustTypeModal && (
        <Modal
          open={adjustTypeModal}
          onCancel={() => setAdjustTypeModal(false)}
          centered
          footer={null}
          maskClosable={false}
        >
          <div style={{ padding: 8 }}>
            <Row justify='center'>
              <Text level={3} fontWeight={700} align='center'>
                คุณต้องการ เพิ่มยอด หรือ ลดยอด <br />
                CO ดูแลราคาแบบ Manual
              </Text>
            </Row>
            <br />
            <Row justify='center'>
              <Text align='center'>
                การเพิ่มยอด หรือ ลดยอด
                <br />
                ส่งผลต่อ ส่วนลดดูแลราคาคงเหลือในระบบ
                <br />
                โปรดตรวจสอบความถูกต้องก่อนการเลือก
              </Text>
            </Row>
            <br />
            <Row gutter={16}>
              <Col span={12}>
                <Button
                  title='+ เพิ่มยอด'
                  typeButton='success'
                  onClick={() => {
                    setAdjustTypeModal(false);
                    setAdjustFormModal({ type: "ADJUST_ADD", open: true });
                  }}
                />
              </Col>
              <Col span={12}>
                <Button
                  title='- ลดยอด'
                  typeButton='danger'
                  onClick={() => {
                    setAdjustTypeModal(false);
                    setAdjustFormModal({ type: "ADJUST_SUB", open: true });
                  }}
                />
              </Col>
            </Row>
          </div>
        </Modal>
      )}
      {adjustFormModal.open && (
        <ModalAdjustForm
          open={adjustFormModal.open}
          type={adjustFormModal.type}
          onClose={(success) => {
            success &&
              (() => {
                setTab("adjustment");
                setPage("1");
                setAdjustFormModal({ type: "", open: false });
                fetchAdjustmentList();
              })();
            !success && setAdjustFormModal({ type: "", open: false });
          }}
          cusComId={id}
        />
      )}
    </>
  );
};

export const ModalAdjustForm: React.FC<{
  open: boolean;
  type: "ADJUST_ADD" | "ADJUST_SUB";
  onClose: (success: boolean) => void;
  cusComId: string;
}> = ({ open, type, onClose, cusComId }) => {
  const { messageApi } = useMessageContext();
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [form] = Form.useForm();
  const [fileRef, setFileRef] = useState<any>([]);
  const [coList, setCoList] = useState<any>([]);
  const _watchCoShopId = Form.useWatch(["coShopId"], form);
  const _watchAdjustAmount = Form.useWatch(["adjustAmount"], form);
  const _watchRemark = Form.useWatch(["adjustRemark"], form);
  const [confirmModal, setConfirmModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const optionRemark = [
    { label: "คืนเป็นเงินโอน", value: "คืนเป็นเงินโอน", key: 1 },
    { label: "คืนเป็นสินค้า", value: "คืนเป็นสินค้า", key: 2 },
    { label: "ยกยอดไปรวมกับรายการส่วนลดใหม่", value: "ยกยอดไปรวมกับรายการส่วนลดใหม่", key: 3 },
    { label: "อื่นๆ", value: "อื่นๆ", key: 4 },
  ];

  const fetchData = async () => {
    await getShopCoListByShopId({ company: profile?.company, customerCompanyId: cusComId }).then(
      (res) => {
        const mapColList = res?.coBreakdown?.filter((co: any) => co.status === "ACTIVE") || [];
        mapColList.length === 1 && form.setFieldsValue({ coShopId: mapColList[0].coShopId });
        setCoList(mapColList);
      },
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const checkValidation = async () => {
    try {
      await form.validateFields();
      setConfirmModal(true);
    } catch (e) {
      console.log("error", e);
    }
  };

  const handleSubmit = async () => {
    const formValues = form.getFieldsValue(true);
    const payload = {
      updateBy: profile?.firstname + " " + profile?.lastname,
      coShopId: formValues.coShopId,
      type: type,
      amount: formValues.adjustAmount,
      reason:
        formValues.adjustRemark === "อื่นๆ"
          ? formValues.adjustRemarkOther
          : formValues.adjustRemark,
    };
    await createAdjustCoShop(payload, fileRef).then((res) => {
      if (res.success) {
        setConfirmModal(false);
        messageApi.success("ปรับยอดสำเร็จ");
        onClose(res.success);
      }
    });
    setTimeout(() => {
      setSubmitting(false);
    }, 1000);
  };

  return (
    <>
      <Modal
        open={open}
        closeIcon={false}
        centered
        maskClosable={false}
        okText='บันทึก'
        onCancel={() => onClose(false)}
        onOk={() => checkValidation()}
        cancelButtonProps={{ style: { color: color.primary, borderColor: color.primary } }}
      >
        <Row justify='start'>
          <Text
            level={3}
            fontWeight={600}
            align='center'
            color={type === "ADJUST_ADD" ? "success" : "error"}
          >
            {type === "ADJUST_ADD" ? "เพิ่มยอด" : "ลดยอด"}
          </Text>
          &nbsp;&nbsp;
          <Text level={3} fontWeight={600}>
            CO ดูแลราคาแบบ Manual
          </Text>
        </Row>
        <br />
        <Form form={form} layout='vertical'>
          <Col span={24}>
            <Form.Item
              label='รายการที่ต้องการปรับยอด'
              name='coShopId'
              rules={[
                {
                  required: true,
                  message: "โปรดเลือกรายการที่ต้องการปรับยอด",
                },
              ]}
              required
            >
              <Select
                placeholder='เลือกรายการ'
                data={coList?.map((co) => ({
                  label: co.coName,
                  value: co.coShopId,
                  key: co.coShopId,
                }))}
                onChange={() => {
                  form.setFieldsValue({ adjustAmount: undefined });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='หมายเหตุในการปรับยอด'
              name='adjustRemark'
              rules={[
                {
                  required: true,
                  message: "โปรดระบุหมายเหตุในการปรับยอด",
                },
              ]}
              required
            >
              <Select placeholder='ระบุหมายเหตุในการปรับยอด' data={optionRemark || []} />
            </Form.Item>
          </Col>
          {form.getFieldValue("adjustRemark") === "อื่นๆ" && (
            <Col span={24}>
              <Form.Item
                label='ระบุหมายเหตุอื่นๆ'
                name='adjustRemarkOther'
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุหมายเหตุอื่นๆ",
                  },
                ]}
                required
              >
                <Input placeholder='ระบุหมายเหตุอื่นๆ' autoComplete='off' />
              </Form.Item>
            </Col>
          )}
          <Col span={24}>
            <Form.Item
              label={type === "ADJUST_ADD" ? "จำนวนยอดที่เพิ่ม" : "จำนวนยอดที่ลด"}
              name='adjustAmount'
              rules={[
                {
                  required: true,
                  message:
                    type === "ADJUST_ADD" ? "โปรดระบุจำนวนยอดที่เพิ่ม" : "โปรดระบุจำนวนยอดที่ลด",
                },
                {
                  validator: (_, value) => {
                    const find =
                      _watchCoShopId && coList?.find((co: any) => co.coShopId === _watchCoShopId);
                    if (type === "ADJUST_SUB" && value > 0 && find.quotaAvailable > 0) {
                      if (find && value > find.quotaAvailable) {
                        return Promise.reject(
                          new Error("จำนวนที่ลดต้องเท่ากับหรือน้อยกว่ายอดปัจจุบัน"),
                        );
                      }
                    }
                    if (value && value <= 0) {
                      return Promise.reject(new Error("จำนวนต้องมากกว่า 0"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              required
            >
              <Input
                placeholder={type === "ADJUST_ADD" ? "ระบุจำนวนยอดที่เพิ่ม" : "ระบุจำนวนยอดที่ลด"}
                autoComplete='off'
                onKeyDown={onInputNumberKeyPress}
              />
            </Form.Item>
          </Col>
          {_watchCoShopId && (
            <Card bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
              <Row justify={"space-between"}>
                <Col>
                  <Text level={6}>ยอดปัจจุบัน :</Text>
                </Col>
                <Col>
                  <Text level={6}>
                    {(() => {
                      const co = coList?.find((co: any) => co.coShopId === _watchCoShopId);
                      return co ? numberFormatter(co.quotaAmount - co.quotaUsed) + " ฿" : "-";
                    })()}
                  </Text>
                </Col>
              </Row>
              <Row justify={"space-between"}>
                <Col>
                  <Text level={6}>ยอดหลังแก้ไข:</Text>
                </Col>
                <Col>
                  <Text
                    fontWeight={600}
                    level={6}
                    color={type === "ADJUST_ADD" ? "success" : "error"}
                  >
                    {(() => {
                      const co = coList?.find((co: any) => co.coShopId === _watchCoShopId);
                      const cal = co
                        ? type === "ADJUST_ADD"
                          ? co.quotaAmount - co.quotaUsed + Number(_watchAdjustAmount || 0)
                          : co.quotaAmount - co.quotaUsed - Number(_watchAdjustAmount || 0)
                        : 0;
                      return cal !== co?.quotaAmount - co?.quotaUsed ? (
                        numberFormatter(cal || 0) + " ฿"
                      ) : (
                        <Text color='Text1'>-</Text>
                      );
                    })()}
                  </Text>
                </Col>
              </Row>
            </Card>
          )}
          <Col span={24}>
            <Text level={6} fontFamily='Sarabun'>
              แนบเอกสารอ้างอิงจาก
            </Text>
            <Card bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
              <Row gutter={8} justify={"start"}>
                <Col span={5}>
                  <Upload
                    disabled={fileRef?.length > 0}
                    accept='image/*'
                    style={{ width: "100%" }}
                    action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
                    onChange={(info) => {
                      let newFileList = [...info.fileList];
                      newFileList = newFileList.slice(-2);
                      newFileList = newFileList.map((file) => {
                        if (file.response) {
                          file.url = file.response.url;
                        }
                        return file;
                      });
                      setFileRef(newFileList);
                    }}
                    fileList={fileRef}
                    beforeUpload={() => false}
                    showUploadList={false}
                  >
                    <Button
                      typeButton={fileRef?.length > 0 ? "disabled" : "primary"}
                      title='เลือกไฟล์'
                      height={40}
                    />
                  </Upload>
                </Col>
                <Col span={17} style={{ paddingTop: "8px" }}>
                  {fileRef?.length > 0 ? (
                    <Text
                      color='primary'
                      style={{ cursor: "pointer" }}
                      onClick={() => window.open(fileRef[0]?.url, "_blank")}
                    >
                      {fileRef[0]?.name.length > 30
                        ? `${fileRef[0]?.name.slice(0, 30)}...pdf`
                        : fileRef[0]?.name}
                    </Text>
                  ) : (
                    <>
                      <Col>
                        <Text level={6} color='Text3'>
                          โปรดเลือกไฟล์
                        </Text>
                      </Col>
                    </>
                  )}
                </Col>
                {fileRef?.length > 0 && (
                  <Col style={{ paddingTop: "8px" }}>
                    <DeleteFilled style={{ color: color.error }} onClick={() => setFileRef([])} />
                  </Col>
                )}
              </Row>
            </Card>
          </Col>
        </Form>
      </Modal>
      {confirmModal && (
        <Modal
          open={confirmModal}
          maskClosable={false}
          keyboard={false}
          onCancel={() => setConfirmModal(false)}
          centered
          cancelButtonProps={{ style: { borderColor: color.primary, color: color.primary } }}
          title={
            <Text level={2} fontWeight={600}>
              ยืนยันการบันทึกข้อมูล
            </Text>
          }
          confirmLoading={submitting}
          okText='ยืนยัน'
          onOk={() => {
            setSubmitting(true);
            setTimeout(() => {
              handleSubmit();
            }, 1000);
          }}
        >
          <Text>
            โปรดตรวจสอบ{" "}
            <Text color={type === "ADJUST_ADD" ? "success" : "error"} fontWeight={600}>
              {type === "ADJUST_ADD" ? "การเพิ่มยอด" : "การลดยอด"}
            </Text>{" "}
            CO ส่วนลดดูแลราคา ก่อนกดยืนยัน เพราะอาจส่งผลต่อยอดส่วนลดดูแลราคาคงเหลือในระบบ
          </Text>
        </Modal>
      )}
    </>
  );
};
